export const DEFAULT_PIXELS_PER_MINUTE: number = 1;
